import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useLogin } from "../apiCalls/authApiCalls";
import { Button, Field, Input } from "../components/ui";
import { isAdmin } from "../session";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { mutate: signIn, isLoading } = useLogin();

  if (isAdmin()) return <Navigate to="/" replace />;

  const handleSubmit = (event) => {
    event.preventDefault();
    signIn({ email, password });
  };

  return (
    <div className="flex min-h-screen">
      {/* The same court photograph the public site's hero uses, so the two
          products open on one image. Unlike the hero it is not washed out —
          nothing but the wordmark sits on top of it here. */}
      <div
        aria-hidden="true"
        className="relative hidden flex-1 items-end overflow-hidden bg-ink lg:flex"
      >
        <img
          src={`${process.env.PUBLIC_URL}/hero-court.jpg`}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
        />
        {/* Keeps the wordmark legible over the bright part of the sky. */}
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/40 to-transparent" />
        <div className="relative p-16">
          <div className="font-display text-2xl font-bold uppercase tracking-tight text-white">
            PadelRank
          </div>
          <div className="mt-1 font-mono text-xs uppercase tracking-widest text-white/70">
            Control room
          </div>
        </div>
      </div>

      <div className="flex flex-1 items-center justify-center px-6 py-16">
        <div className="w-full max-w-sm">
          {/* On lg the wordmark lives on the photograph instead. */}
          <div className="lg:hidden">
            <div className="font-display text-sm font-bold uppercase tracking-tight">
              PadelRank
            </div>
            <div className="font-mono text-xs uppercase tracking-widest text-teal">
              Control room
            </div>
          </div>

          <h1 className="mt-8 font-display text-3xl font-bold uppercase tracking-tight lg:mt-0">
            Sign in
          </h1>
          <div className="court-rule mt-4" />

          <form onSubmit={handleSubmit} className="mt-8 flex flex-col gap-5">
            <Field label="Email">
              <Input
                type="email"
                autoComplete="username"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </Field>

            <Field label="Password">
              <Input
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </Field>

            <Button type="submit" variant="primary" disabled={isLoading}>
              {isLoading ? "Signing in" : "Sign in"}
            </Button>
          </form>

          <p className="mt-6 text-xs text-ink-soft">
            Administrator accounts only. Players sign in on the public site.
          </p>
        </div>
      </div>
    </div>
  );
}
